import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            Everything you need to know about our Pandabuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}